module.exports = __webpack_public_path__ + "4a5180781db4fcfa33e7a667e2b545ea.svg";